<template functional>
  <div :class="['info-container', data.class, data.staticClass]">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'InfoContainer'
}
</script>

<style lang="scss">
$infocontainer-gap: 3px !default;
$infocontainer-padding-y: $spacer * 1.25 !default;
$infocontainer-padding-x: $infocontainer-padding-y !default;
$infocontainer-bg: $light !default;
$infocontainer-border-radius: $border-radius !default;

$infocontainer-hr-margin-y: $spacer * 0.5 !default;

.info-container  {
  padding: $infocontainer-padding-y $infocontainer-padding-x;
  background-color: $infocontainer-bg;
  border-radius: $infocontainer-border-radius;

  > hr {
    margin-top: $infocontainer-hr-margin-y;
    margin-bottom: $infocontainer-hr-margin-y
    ;
  }

  + .info-container {
    margin-top: $infocontainer-gap;
  }
}
</style>
